export default __webpack_public_path__ + "static/media/btc.a83399ab.svg";